import {axiosReactClient} from '../axios';

export async function getSearchSuggestions(
  searchToken: string,
  includeOutOfStock = false,
) {
  const encodedSearchToken = encodeURIComponent(searchToken);
  const {data} = await axiosReactClient.get<
    Array<{
      key: string;
      value: string;
      handle?: string;
    }>
  >(
    `/products/suggestions/${encodedSearchToken}${
      includeOutOfStock ? '?inStock=any' : ''
    }`,
  );
  return data;
}

export async function getRequestSuggestions(searchToken: string) {
  const encodedSearchToken = encodeURIComponent(searchToken);
  const {data} = await axiosReactClient.get<
    Array<{
      id: string;
      title: string;
      handle: string;
    }>
  >(`/products/request-suggestions/${encodedSearchToken}`);
  return data;
}
